import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles(() => ({
  changePasswordContainer: {
    padding: '0 24px',
  },
  title: {
    fontSize: '20px',
    fontWeight: 600 + '!important',
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT1,
    marginBottom: '24px' + ' !important',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '24px',
  },
  saveButton: {
    minWidth: '160px !important',
  },
  passwordField: {
    marginTop: '24px !important',
  },
}));
